import { motion } from "framer-motion";
import { Compass, GraduationCap, Clapperboard } from "lucide-react";
import { fadeUp, staggerContainer, viewportOnce } from "../../lib/motion";

const SERVICES = [
  {
    n: "01",
    icon: Compass,
    title: "Technical Consulting",
    body: "Strategic guidance and systems architecture for organizations working through complex digital transformation.",
  },
  {
    n: "02",
    icon: GraduationCap,
    title: "Training for Complex Environments",
    body: "Custom learning programs and LMS deployments engineered for tactical, high-stakes, and remote operations.",
  },
  {
    n: "03",
    icon: Clapperboard,
    title: "Digital Media Production",
    body: "High-precision digital media — from instructional content to brand assets built with cinematic craft.",
  },
];

export const Services = () => {
  return (
    <section id="services" className="section-pad relative" data-testid="services-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="mb-16"
        >
          <motion.p variants={fadeUp} className="overline overline-dark mb-6">/ Capabilities</motion.p>
          <motion.h2 variants={fadeUp} className="font-display text-5xl tracking-tight text-[#0C2340] md:text-7xl">
            What we <span>do.</span>
          </motion.h2>
        </motion.div>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="grid grid-cols-1 md:grid-cols-3"
        >
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.n}
                variants={fadeUp}
                data-testid={`service-${s.n}`}
                className={`group relative px-2 py-10 md:px-8 ${
                  i !== 0 ? "md:border-l md:border-[#0C2340]/10" : ""
                }`}
              >
                <div className="flex items-center justify-between">
                  <Icon size={32} strokeWidth={1.3} className="text-[#0C2340] transition-transform duration-500 group-hover:-translate-y-1" />
                  <span className="font-display text-5xl metallic-number-dark">{s.n}</span>
                </div>
                <div className="hairline-light my-7" />
                <h3 className="font-display text-2xl text-[#0C2340] md:text-3xl">{s.title}</h3>
                <p className="mt-4 font-body text-base leading-relaxed text-[#1E3A5F]">{s.body}</p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};
